import { MROType } from '../../app/features/vehicles/infrastructure/enums/mro-type.enum';
import { BilletSubjectType } from '../../app/features/wallet/infrastructure/enums/billet-subject-type.enum';
import { InvoiceNameStatus } from '../../app/features/wallet/infrastructure/enums/invoice-name-status.enum';
import { InvoiceReason } from '../../app/features/wallet/infrastructure/enums/invoice-reason.enum';
import { InvoiceType } from '../../app/features/wallet/infrastructure/enums/invoice-type.enum';
import { InvoiceDetail } from '../../app/features/wallet/infrastructure/interfaces/invoices.interface';

export const InvoiceDetailMock: InvoiceDetail = {
    id: 'd8c950g9-0b86-5e13-08eg-79e0b8e7b66d',
    invoiceNumber: 'INV-1234',
    issueDate: '2025-06-27T04:00:00Z',
    status: {
        name: InvoiceNameStatus.DRAFT,
        reason: InvoiceReason.INVOICE_OPEN,
        dateTime: '2025-06-27T04:00:00Z',
    },
    type: InvoiceType.REFUND,
    billingPeriod: {
        startDate: '2025-03-31T04:00:00Z',
        endDate: '2025-06-27T04:00:00Z',
    },
    billTo: {
        name: 'John Doe',
        userId: 'd8c950g9-0b86-5e13-08eg-79e0b8e7b66d',
    },
    paymentDetails: {
        paymentDate: '2025-06-27T04:00:00Z',
        paymentMethod: 'Credit Card *7896',
        subtotalAmount: {
            amount: 0.06,
            currency: 'USD',
        },
        totalAmount: {
            amount: 24.06,
            currency: 'USD',
        },
    },
    summary: {
        subtotalAmount: {
            amount: 22.57,
            currency: 'USD',
        },
        totalAmount: {
            amount: 24.06,
            currency: 'USD',
        },
    },
    lineItems: [
        {
            id: 'd8c950g9-0b86-5e13-08eg-79e0b8e7b66d',
            concept: 'Activity 1',
            amount: {
                amount: 24.06,
                currency: 'USD',
            },
            billedSubject: {
                type: BilletSubjectType.VEHICLE,
                vehicle: {
                    vin: 'JH4DA9470MS016525',
                    licensePlate: 'KIA-1234',
                    licensePlateState: 'CA',
                    mroType: MROType.ODOMETER_CAPTURE,
                    details: {
                        make: 'Kia',
                        model: 'Niro Hybrid',
                        year: 2023,
                    },
                },
                user: {
                    userId: 'd8c950g9-0b86-5e13-08eg-79e0b8e7b66d',
                },
            },
            activityIds: ['d8c950g9-0b86-5e13-08eg-79e0b8e7b66d'],
        },
    ],
};
